$(document).ready(function() { 
  if (location.pathname === '/cart') {

    $('.cart__dynamic-checkout-buttons').hide(); 

    var today = new Date();
    var minDate = 0;
  
    $('.shipping-method-tybo').on('change', function() {
      $('.tybo-date-input').val('');

      loadNextDate()  

      if ($(this).val().length) {  
        $('.tybo-date-input').prop('disabled', false);
        $('.tybo-date-input').prop('readonly', true);
      } else {
        $('.tybo-date-input').prop('disabled', true);
        $('.tybo-date-input').prop('readonly', false);
      }

      var today = new Date();

      /*if (today.getDay() === 4) {  
        $('.cart__dynamic-checkout-buttons').hide(); 
        $('#tybo-shipping-date').prop('disabled', true);
        $('#tybo-shipping-date').prop('readonly', false); 
      } else if (today.getDay() === 5 && today.getHours() < 12) {   
        $('.cart__dynamic-checkout-buttons').hide(); 
        $('#tybo-shipping-date').prop('disabled', true);
        $('#tybo-shipping-date').prop('readonly', false);
      } else {*/ 
        // $('.cart__dynamic-checkout-buttons').show();  
        $('#tybo-shipping-date').prop('disabled', false);
        $('#tybo-shipping-date').prop('readonly', true); 
      // } 
      
      if ($(this).val() == 'Pickup') {             
        $('.pickup-time-tybo-cont').show();
        $('.shipping-terms').hide();
        $('.tybo-shipping-terms').hide(); 
      } else {
        $('.pickup-time-tybo-cont').hide(); 
        $('.shipping-terms').show();
      }
    });
  
    $('.custom-tybo-checkout').click(function() { 
      $('.tybo-qty-validation').hide(); 
      $('.tybo-shipping-validation').hide();
      $('.tybo-pickup-time-validation').hide();
      var shippingMethod = $('.shipping-method-tybo').val();
      var shippingDate = $('.tybo-date-input').val() ? $('.tybo-date-input').val() : false; 
      var pickupTime = $('.pickup-time-tybo').val(); 

      $.getJSON('/cart.js', function(cart) {
        if (!shippingMethod.length || !shippingDate.length) { 
          $('.tybo-shipping-validation').show();
        } else if ($('.shipping-method-tybo').val() == 'Shipping' && !$("#agree-shipping").is(":checked")) {
          $('.tybo-shipping-terms').show(); 
        } else {   
          var attributes = {};
    
          attributes['Shipping Method'] = shippingMethod;
    
          if (shippingMethod == 'Pickup') {
            attributes['Pickup Date'] = shippingDate;
            attributes['Pickup Time'] = pickupTime;
            attributes['Shipping Date'] = null;
          } else {
            attributes['Shipping Date'] = shippingDate;
            attributes['Pickup Date'] = null;
            attributes['Pickup Time'] = null;
          } 
          
          $.ajax({ 
            type: 'POST',
            url: '/cart/update.js',
            data: {
              'attributes': attributes 
            },
            dataType: 'json',
            success: function() {  
              $('.cart__checkout-button').click();
            } 
          });
        }
      }); 
    });
  }

  /*function getDaysUntilNextMonday() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let daysUntilMonday;
  
    if (dayOfWeek === 1) {
      daysUntilMonday = 7;
    } else if (dayOfWeek === 0) {
      daysUntilMonday = 1;
    } else {
      daysUntilMonday = 8 - dayOfWeek;
    }
  
    return daysUntilMonday;
  }*/

  function getDaysUntilNextMonday() {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // If today is Sunday (0) or Monday (1), return days until the *following* Monday
    if (dayOfWeek === 0) return 8; // Sunday → next Monday is 8 days away
    if (dayOfWeek === 1) return 7; // Monday → next Monday is 7 days away

    // Otherwise, return days until the upcoming Monday
    return (8 - dayOfWeek);
  }

  function getDaysUntilNextTuesday() {
    const today = new Date();
    const dayOfWeek = today.getDay();

    // If today is Wednesday (3) or later, return days until the *following* Tuesday
    return (dayOfWeek >= 3) ? (9 - dayOfWeek) : (2 - dayOfWeek);
  }

  function getDaysUntilNextFriday() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let daysUntilFriday;
  
    if (dayOfWeek === 5) {
      daysUntilFriday = 7;
    } else {
      daysUntilFriday = (5 + 7 - dayOfWeek) % 7;
    }
  
    return daysUntilFriday === 0 ? 7 : daysUntilFriday;
  } 
  
  function loadNextDate() {
    // var select = $('#tybo-shipping-date');
    // select.empty(); 

    // var today = new Date();
    // var nextDate = new Date(today);
        
    const select = $('#tybo-shipping-date');
    const today = new Date();
    const currentDay = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
    const currentHour = today.getHours(); // 0–23

    select.empty(); // Clear previous options
    select.append($('<option>', {
        value: '',
        text: 'Please select'
    }));

    const method = $('.shipping-method-tybo').val();

    if (method === 'Shipping') {
        // Helper to get next Monday
        function getDaysUntilNextMonday(offsetWeeks = 0) {
            const daysUntilMonday = (1 - currentDay + 7) % 7 || 7;
            return daysUntilMonday + offsetWeeks * 7;
        }

        const isMondayAfterNoon = (currentDay === 1 && currentHour >= 12);
        const isSaturdayMidnightOrLater = (currentDay === 6 && currentHour >= 0);

        const offsetWeeks = isSaturdayMidnightOrLater ? 1 : 0;
        const daysUntilNextMonday = getDaysUntilNextMonday(offsetWeeks);

        if (!isMondayAfterNoon) {
            const nextMonday = new Date();
            nextMonday.setDate(today.getDate() + daysUntilNextMonday);
            const formattedDate = nextMonday.toISOString().split('T')[0];

            select.append($('<option>', {
                value: formattedDate,
                text: formattedDate
            }));
        }

    } else if (method === 'Pickup' || method === 'Delivery') {
        // Start from 24 hours after now
        const startDate = new Date(today.getTime() + 24 * 60 * 60 * 1000);

        for (let i = 0; i < 7; i++) {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            const day = date.getDay();

            if (day === 0) break; // Stop at Sunday

            const formattedDate = date.toISOString().split('T')[0];
            select.append($('<option>', {
                value: formattedDate,
                text: formattedDate
            }));
        }
    }

    /*nextDate.setDate(today.getDate() + daysUntilNextDate)  

    // Ajuste de la hora a 15:00 (3 p.m.) 
    nextDate.setHours(15); 
    nextDate.setMinutes(0);
    nextDate.setSeconds(0);

    var formattedDate = nextDate.toISOString().slice(0, 10);

    select.append($('<option>', {
        value: '',
        text: 'Please select' 
    }));

    select.append($('<option>', {
        value: formattedDate,
        text: formattedDate
    }));*/   
  } 

  loadNextDate() 

  $('#tybo-shipping-date').change(function() {
    var selectedDate = $(this).val();
    var shippingMethod = $('.shipping-method-tybo').val();

    if (shippingMethod == 'Pickup') {
      if (selectedDate) {
        $('.pickup-time-tybo').prop('disabled', false);
      } else {
        $('.pickup-time-tybo').prop('disabled', true);
      }
    }
  }); 
});